// extracted by mini-css-extract-plugin
export var wordContainer = "_ph-0";